import React from 'react'
import styles from '../styles/exp.css'
import {motion} from 'framer-motion'
import Project from './Project'
import carfax from '../images/carfax.jpg'
import green from '../images/green.webp'
import beacon from '../images/beacon.png'

function Experience() {
  return (
    <div className='exp'>
        <motion.h2 
        initial={{opacity: 0, y: 50}}
        whileInView={{opacity: 1, y:0}}
        transition={{type: "just",duration: 0.5}}
        id='heading'>My Work Experience</motion.h2>
        <motion.p
        initial={{opacity: 0, y: 50}}
        whileInView={{opacity: 1, y:0}}
        transition={{type: "just",duration: 0.5}}
        className="caption title para">Discover my past experience and unlock a world of skills and achievements</motion.p>
            <div className='cols'>
                <div className='row_1'>
                    <Project img={carfax} title={"CARFAX"} link={"https://www.carfax.com/"} github={false}/>
                    <motion.div 
                    initial={{opacity: 0, x: 100}}
                    whileInView={{opacity: 1, x:0}}
                    transition={{type: "just",duration: 0.5}}
                    className='row_content'>
                        <h2>CARFAX</h2>
                        <h4>Associate Software Engineer | Centerville, VA </h4>
                        <h5>March 2022 - Present</h5>
                        <p className='caption detail'>At CARFAX, as an iOS Software Engineer, I worked on the internal iPad application FoxDen, created streamlined reports, contributed to increased test coverage, and developed features like a print function and reusable UI tooltips, resulting in improved sales rep efficiency and positive user feedback.</p>
                    </motion.div>
                </div>

                <div className='row_1 row_2'>     
                    <motion.div 
                    initial={{opacity: 0, x: -100}}
                    whileInView={{opacity: 1, x:0}}
                    transition={{type: "just",duration: 0.5}}
                    className='row_content'>
                        <h2>GREENSTAND</h2>
                        <h4>GREENSTAND | iOS Software Engineer | Anchorage, AK</h4>
                        <h5>Sept 2021 - March 2022</h5>
                        <p className='caption detail'>During my tenure as an iOS Software Engineer at Greenstand, I developed tech solutions to combat deforestation, refactored user interface layouts, and created responsive UIs, enhancing user experience for more than 1,000 users across all devices.</p>
                    </motion.div>
                    <Project img={green} title={"GREENSTAND"} link={"https://www.greenstand.org/"} github={false} />
                </div>

                <div className='row_1'>
                    <Project img={beacon} title={"BEACON"} link={null} github={false}/>
                    <motion.div 
                    initial={{opacity: 0, x: 100}}
                    whileInView={{opacity: 1, x:0}}
                    transition={{type: "just",duration: 0.5}}
                    className='row_content'>
                        <h2>BEACON</h2>
                        <h4>iOS Software Engineer Intern | New York, NY</h4>
                        <h5>March 2021 - May 2021</h5>
                        <p className='caption detail'>As an iOS Software Engineer Intern at Beacon, I contributed to the development of an iOS app for organizing social events, improved image upload efficiency, and created reusable UI components that increased the code velocity of developers by 20%</p>
                    </motion.div>
                </div>
            </div>
    </div>
  )
}

export default Experience